<!--
Copyright 2022 LINE Fukuoka Corporation

LINE Corporation licenses this file to you under the Apache License,
version 2.0 (the "License"); you may not use this file except in compliance
with the License. You may obtain a copy of the License at:

  https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
License for the specific language governing permissions and limitations
under the License.
-->
<template>
  <div>
    <v-text-field
      class="not-print-applicant-details-item"
      v-model="input"
      :counter="counter"
      :rules="[
        validateRequired,
        validateIsPostCode,
      ]"
      :required="required"
      :maxlength="length.max"
      :error-messages="errorMessage"
      append-outer-icon="mdi-magnify"
      @click:append-outer="searchForAddress"
      @blur="searchForAddress"
      :disabled="disabled"
    ></v-text-field>
    <span class="print-applicant-details-item">
      {{ input }}
    </span>
  </div>
</template>

<script>
import Vue from "vue";
import InputShortAnswer from "./InputShortAnswer.vue";
import { requireTextIsPostCode } from "../utils/validationUtils";
import postal_code from "japan-post-code-custom-reup";

export default Vue.extend({
  name: "InputPostCode",
  mixins: [InputShortAnswer],
  props: {mlLibJson:Object,},
  data() {
    return {
      errorMessage: null,
    };
  },
  created() {
    this.length.max = 7;
  },
  methods: {
    validateIsPostCode(input) {
      let is_valid = !input || requireTextIsPostCode(input);
      if (is_valid) {
        return true;
      } else {
        let message = "正しい郵便番号を入力してください。";
        return message;
      }
    },
    async searchForAddress() {
      let address = await postal_code.get(this.input);
      if (address) {
        let result =
          address.prefecture + address.city + address.area + address.street;
        this.$emit("fill-address", result, this.itemKey);
        this.errorMessage = null;
      } else if (this.input.length === 7) {
        this.errorMessage = "住所が見つかりません。直接住所を入力してください";
      } else {
        this.errorMessage = null;
      }
    },
  },
});
</script>
